import { GrupoEleitoresResponseType, GruposEleitoresListType } from '../../types';

import { FaSortNumericDown } from 'react-icons/fa';
import { FunctionComponent } from 'react';
import { LabelValue } from '../../utils';
import { TipoGrupoEleitoresEnum } from '../../enums';
import { useTranslation } from 'react-i18next';

const GruposEleitoresList: FunctionComponent<GruposEleitoresListType> = ({ gruposEleitores }) => {
  const { t } = useTranslation();

  return (
    <div className="list-group">
      {gruposEleitores
        .sort((a, b) => a.prioridade - b.prioridade)
        .map((grupoEleitor: GrupoEleitoresResponseType) => {
          return (
            <div className="list-group-item p-0 d-flex" key={grupoEleitor.id}>
              <div className="list-group-item-numbered d-flex justify-content-between align-items-center">
                <LabelValue
                  label={t('label.prioridade')}
                  value={grupoEleitor.prioridade}
                  icon={FaSortNumericDown}
                  className={'justify-content-start'}
                  noText
                  boldValue
                />
              </div>
              <div className={'px-3 py-2 d-flex flex-column flex-sm-row d-sm-inline-flex w-100'}>
                <div className="col d-flex flex-column flex-md-row justify-content-center align-items-start justify-content-md-start align-items-md-center">
                  <div className="d-flex flex-grow-1 justify-content-start align-items-center fw-bold px-2">
                    {grupoEleitor.denominacao}
                  </div>
                  <div className="d-flex col-12 col-md-6 col-lg-3">
                    <LabelValue
                      label={t(TipoGrupoEleitoresEnum.DOCENTE.descricao)}
                      value={
                        (grupoEleitor.totais?.find((total) => total.tipo === TipoGrupoEleitoresEnum.DOCENTE.key)?.total ?? 0) +
                        (grupoEleitor!.totais?.find((total) => total.tipo === TipoGrupoEleitoresEnum.DOCENTE_EXTERNO.key)
                          ?.total ?? 0)
                      }
                      icon={TipoGrupoEleitoresEnum.DOCENTE.icon}
                      noText
                      boldValue
                      mutedIcon
                      className="col"
                    />
                    <LabelValue
                      label={t(TipoGrupoEleitoresEnum.TECNICO_ADMINISTRATIVO.descricao)}
                      value={
                        grupoEleitor.totais?.find((total) => total.tipo === TipoGrupoEleitoresEnum.TECNICO_ADMINISTRATIVO.key)
                          ?.total
                          ? grupoEleitor.totais?.find(
                              (total) => total.tipo === TipoGrupoEleitoresEnum.TECNICO_ADMINISTRATIVO.key,
                            )?.total
                          : 0
                      }
                      icon={TipoGrupoEleitoresEnum.TECNICO_ADMINISTRATIVO.icon}
                      noText
                      boldValue
                      mutedIcon
                      className="col"
                    />
                    <LabelValue
                      label={t(TipoGrupoEleitoresEnum.DISCENTE.descricao)}
                      value={
                        grupoEleitor.totais?.find((total) => total.tipo === TipoGrupoEleitoresEnum.DISCENTE.key)?.total
                          ? grupoEleitor.totais?.find((total) => total.tipo === TipoGrupoEleitoresEnum.DISCENTE.key)?.total
                          : 0
                      }
                      icon={TipoGrupoEleitoresEnum.DISCENTE.icon}
                      noText
                      boldValue
                      mutedIcon
                      className="col"
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-end align-items-center col-sm-3 col-lg-2">
                  <div>
                    <LabelValue
                      label={t('label.eleitores')}
                      value={
                        grupoEleitor.totais?.length! > 0
                          ? grupoEleitor.totais?.map((ge) => ge.total).reduce((acc, cur) => (acc += cur))
                          : 0
                      }
                      valueFirst
                      boldValue
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default GruposEleitoresList;
